import HomePage from './common/components/HomePage'

export default function Home() {
  return <HomePage />
}
